import React from "react";
import createSvgIcon from "./createSvgIcon";

export default createSvgIcon(
  <path d="M26.37,25.05l-1.32,1.33a1.12,1.12,0,0,1-1.59,0L18.78,21.7a1.1,1.1,0,0,1-.32-.79v-.77a9.83,9.83,0,1,1,1.68-1.69h.77a1.15,1.15,0,0,1,.8.33l4.67,4.68A1.13,1.13,0,0,1,26.37,25.05Zm-7.91-12.6a6,6,0,1,0-6,6A6,6,0,0,0,18.46,12.45Z" />,
  "CompanySearch",
  "0 0 29.41 29.41"
);
